module.exports = __webpack_public_path__ + "img/zan_img@2x.aa97e7c5.png";